/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/blocks/image.scss';

const propTypes = {
    image: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    description: PropTypes.string,
    credit: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    description: null,
    credit: null,
    className: null,
};

const ImageBlock = ({ image, description, credit, className }) => {

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.imageContainer}>
                {image !== null ? (
                    <img className={styles.image} src={image.url} alt={image.alt || null} />
                ) : null}
                <div className={styles.text}>
                    {description !== null ? (
                        <div className={styles.description}>{description}</div>
                    ) : null}
                    {credit !== null ? <div className={styles.credit}> Photo: {credit}</div> : null}
                </div>
            </div>
        </div>
    );
};

ImageBlock.propTypes = propTypes;
ImageBlock.defaultProps = defaultProps;

export default ImageBlock;
